import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@dowty/legal/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyUpdate, registerServiceWorker } from '@dowty/offline';

document.documentElement.lang = navigator.language.toLowerCase().startsWith("de") ? "de" : "en";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registers src/service-worker.ts (see there for what it caches). Production builds only: a worker
// in front of the dev server fights hot reloading.
if (process.env.NODE_ENV === "production") {
  registerServiceWorker(`${process.env.PUBLIC_URL}/service-worker.js`, {
    // Ask before switching: a forced reload could interrupt a half-filled quick-add.
    onUpdate: (registration) => {
      if (window.confirm("A new version of Dowtex is available. Reload to update?")) applyUpdate(registration);
    },
  });
}
